import {
	hasProperty
} from '@/utils/index'
const role= {
	state: {
		roleInfo: {
			id: 0,
			name: '',
			roleLabel: '角色列表'
		}
	},
	mutations: {
		SET_ROLE: (state: any, val: any) => {
			if(val) {
				if(hasProperty(val, "id")) {
					state.roleInfo.id = val.id;
				}
				if(hasProperty(val, "name")) {
					state.roleInfo.name = val.name;
				}
				if(hasProperty(val, "roleLabel")) {
					state.roleInfo.roleLabel = val.roleLabel;
				}
			}else {
				state.roleInfo.id = "";
				state.roleInfo.name = "";
				state.roleInfo.roleLabel = "";
			}
		}
	},
	actions: {
		storeRole({commit}: any, data: any) {
			commit('SET_ROLE', data);
		}
	}
}
export default role;
